import Application from '@ember/application';

export async function initialize(app: Application): Promise<void> {
  app.deferReadiness();

  window.psl = await import('psl');
  window.Sentry = await import('@sentry/ember');

  app.advanceReadiness();
}

export default {
  name: 'load-externals',
  before: 'tracking',
  initialize,
};
